export const adminsSelector = state => state.allMembers.get('admins');
export const activeMembersSelector = state => state.allMembers.get('activeMembers');
export const blockedMembersSelector = state => state.allMembers.get('blockedMembers');
export const isLoadingSelector = state => state.allMembers.get('isLoading');
export const communityInvitationsSelector = state => state.allMembers.get('communityInvitations');
